const initialState = {
    selected_team_members: []
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.teams/LIST_ALL_TEAMS_SUCCESS":
            return {
                ...state,
                filters: action.response.filters,
                data: action.response.data
            };
        case "table.teams/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        default:
            return state;
    }
}
